import filter_icon from './img/filter.svg'
import filter_reset_icon from './img/filter_reset.svg'
import { ButtonWithIcon } from '../Buttons/ButtonWithIcon/ButtonWithIcon';
import './FiltersSave.scss'

const FiltersSave = ({
    saveFilters = () => {},
    loading = false,
    clearSavedFilters = () => {},
    hasSavedFilters
}) => {

    return (
        <div className='filters-save-group'>
            <ButtonWithIcon
                whiteGreen
                icon={hasSavedFilters ? filter_reset_icon : filter_icon}
                size='m'
                onClick={hasSavedFilters ? clearSavedFilters : saveFilters}
                label={hasSavedFilters ? 'Удалить сохраненные фильтры' : 'Сохранить фильтры на моем компьютере'}
                loading={loading}
            />
        </div>

    );
}

export default FiltersSave;